import { useRef, useState, useLayoutEffect } from "react";
import ReceiptsHeading from "../ReceiptsHeading";
import { useEmailContext, type EmailOption } from "../EmailContext";
import Tooltip from "../../core/Tooltip";

function GmailHeading({
  fetchEmailOptions,
}: {
  fetchEmailOptions: (currentEmail: string) => Promise<EmailOption[]>;
}) {
  const { subject, setSubject, isReply } = useEmailContext();
  const subjectRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const displaySubject =
    isReply && subject && !subject.startsWith("Re: ")
      ? `Re: ${subject}`
      : subject;

  const decodeHtmlEntities = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text || "";
    return textArea.value;
  };

  const finalDisplaySubject = decodeHtmlEntities(displaySubject || "");

  useLayoutEffect(() => {
    const checkOverflow = () => {
      if (isReply && subjectRef.current) {
        const element = subjectRef.current;
        const overflowing = element.scrollWidth > element.clientWidth;
        setIsOverflowing(overflowing);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [displaySubject, isReply]);

  return (
    <div className="gmail-header">
      <div className="receipt-heading">
        <ReceiptsHeading fetchEmailOptions={fetchEmailOptions} />
      </div>
      <div className="reply-heading">
        {isReply ? (
          isOverflowing ? (
            <Tooltip content={finalDisplaySubject} position="bottom center">
              <div ref={subjectRef} className="subject-display">
                {finalDisplaySubject}
              </div>
            </Tooltip>
          ) : (
            <div ref={subjectRef} className="subject-display">
              {finalDisplaySubject}
            </div>
          )
        ) : (
          <input
            type="text"
            placeholder="Subject"
            className="input-header"
            value={finalDisplaySubject}
            onChange={(e) => setSubject(e.target.value)}
          />
        )}
      </div>
    </div>
  );
}

export default GmailHeading;
